import { network } from 'services/network';

export const setEmailNotificationStatus = (params) => {
    const { send_notification } = params;
    return network
        .post(`api/bo/notification/setEmailNotificationStatus?send_notification=${send_notification}`)
        .then((response) => response.data);
};
